"use strict";

import $ from "jquery";

$(document).on("turbolinks:load", function () {
  $("#quick_jump_form select").on("change", function () {
    $(this).closest("form").submit();
  });
});
